import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import {
  Autocomplete,
  Box,
  Chip,
  CircularProgress,
  IconButton,
  InputBase,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography
} from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import ContentSection from '../../containers/Resources/ContentSection';
import { useDispatch } from 'react-redux';
import {
  getContentByCategories,
  getContentTags,
  getAllContentBySection,
  revertResources
} from '../../redux/reducers/resourcesSlice';
import { getSectionList } from '../../redux/reducers/contentSlice';
import { useSelector } from 'react-redux';
import { getAuthData } from '../../config/cookie';
import { getUserList } from '../../redux/reducers/usersSlice';
import { colorSecondary, colorTextGrey } from '../../config/theme';
import SnackBarBox from '../../components/SnackBarBox';
import { createTitle, handleError, isArrayNotEmpty } from '../../utils/utils';
import { getGamificationPoints } from '../../redux/reducers/layoutSlice';
import _, { initial } from 'lodash';
import {
  getNoAuthGradeList,
  getThemeList,
  getMediumList,
  getUnitsByGrade
} from '../../redux/reducers/mastersSlice';
import { ADMIN_ROLE_TYPE } from '../../utils/constant';
import {
  ALLOWED_CONTENT_TYPE_OPTIONS,
  mapContentTypeToApi
} from '../../utils/navigationMenu';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,

  marginLeft: 0,
  marginRight: 10,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  // padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  right: 6,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

let searchValue = '';
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  height: '2rem',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1.5),
    paddingRight: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    width: searchValue ? '28ch' : '0px',
    border: searchValue ? '1px solid #CBD2D9' : '',
    borderRadius: searchValue ? '8px' : '',
    [theme.breakpoints.up('sm')]: {
      '&:focus': {
        width: searchValue ? '28ch' : '28ch',
        border: '1px solid #CBD2D9',
        borderRadius: '8px'
      }
    }
  }
}));

export default function Resources() {
  const dispatch = useDispatch();
  const [initialValues, setInitalValues] = useState({
    tabValue: 0,
    page: 0,
    size: 50,
    searchFilter: ''
  });
  const [grade, setGrade] = useState();
  const [placeholder, setPlaceholder] = useState('Select grade');
  const [tags, setTags] = useState([]);
  const [theme, setTheme] = useState();
  const [themePlaceholder, setThemePlaceholder] = useState('Select theme');
  const [medium, setMedium] = useState();
  const [mediumPlaceholder, setMediumPlaceholder] = useState('Select medium');
  const [unit, setUnit] = useState();
  const [unitPlaceholder, setUnitPlaceholder] = useState('Select unit');
  const [contentType, setContentType] = useState();
  const [contentTypePlaceholder, setContentTypePlaceholder] = useState(
    'Select content type'
  );
  const [extraFlashcards, setExtraFlashcards] = useState([]);

  const {
    contentByCategories,
    isGetContentTagsSuccess,
    contentTagList,
    isGetContentLoading,
    isUpdateLikeDislikeLoading,
    isUpdateLikeDislikeSuccess,
    isShareDetailsLoading,
    isShareDetailsSuccess,
    shareDetailsResponse,
    isShareDetailsFailed,
    shareDetailsErrorContainer,
    isGamificationLoading,
    isGamificationSuccess,
    isDeleteGamificationLoading,
    isDeleteGamificationSuccess
  } = useSelector(state => state.resource);
  const { authData } = useSelector(state => state.auth);
  const { sectionList } = useSelector(state => state.content);
  const [contentTags, setContentTags] = useState([]);
  const contentDataList =
    contentByCategories?.payload?.dataList ??
    contentByCategories?.dataList ??
    [];

  // Prefer section metadata so flashcard fetch does not re-run on every categories response
  const flashcardsSectionId = useMemo(() => {
    const fromMetadata = (sectionList || []).find(section =>
      (section?.sectionName || '').toLowerCase().includes('flashcard')
    );

    return fromMetadata?.contentSectionId || null;
  }, [sectionList]);

  const isFlashcardUpload = item => {
    const uploadType = (item?.upload_type || item?.uploadType || '')
      .replace(/\s+/g, '')
      .toLowerCase();

    return uploadType === 'flashcard' || uploadType === 'flashcards';
  };

  const homeSections = useMemo(() => {
    const getOrder = (name = '') => {
      const normalized = name.toLowerCase().replace(/\s+/g, '');
      if (normalized.includes('lessonplan')) return 1;
      if (normalized.includes('flashcard')) return 2;
      return 99;
    };

    const isLessonPlanSection = name =>
      (name || '').toLowerCase().replace(/\s+/g, '').includes('lessonplan');

    const flashcardItems = [];
    const nonFlashcardSections = [];

    contentDataList.forEach(section => {
      const sectionName = section?.sectionName || '';

      if (sectionName.toLowerCase().includes('flashcard')) {
        flashcardItems.push(...(section?.contents || []));
        return;
      }

      const remainingContents = (section?.contents || []).filter(
        item => !isFlashcardUpload(item)
      );

      flashcardItems.push(
        ...(section?.contents || []).filter(item => isFlashcardUpload(item))
      );

      if (remainingContents.length > 0) {
        nonFlashcardSections.push({
          ...section,
          contents: remainingContents
        });
      }
    });

    flashcardItems.push(...extraFlashcards.filter(isFlashcardUpload));

    const seen = new Set();
    const uniqueFlashcards = flashcardItems
      .map(item => ({
        ...item,
        upload_type: item?.upload_type || item?.uploadType || 'Flashcard',
        uploadType: item?.uploadType || item?.upload_type || 'Flashcard'
      }))
      .filter(item => {
        const id = item?.content_id || item?.contentId;

        if (!id) {
          return true;
        }

        if (seen.has(id)) {
          return false;
        }

        seen.add(id);
        return true;
      });

    const orderedSections = [...nonFlashcardSections].sort(
      (a, b) => getOrder(a?.sectionName) - getOrder(b?.sectionName)
    );

    if (uniqueFlashcards.length === 0) {
      return orderedSections;
    }

    const flashcardsSection = {
      sectionName: 'Flashcards',
      sectionId:
        flashcardsSectionId ||
        uniqueFlashcards[0]?.sectionId ||
        uniqueFlashcards[0]?.section_id,
      contents: uniqueFlashcards,
      videoCount: 0,
      documentCount: 0,
      audioCount: 0,
      flashcardCount: uniqueFlashcards.length
    };

    const result = [];
    let flashcardsInserted = false;

    orderedSections.forEach(section => {
      result.push(section);

      if (isLessonPlanSection(section?.sectionName) && !flashcardsInserted) {
        result.push(flashcardsSection);
        flashcardsInserted = true;
      }
    });

    if (!flashcardsInserted) {
      result.push(flashcardsSection);
    }

    return result;
  }, [contentDataList, extraFlashcards, flashcardsSectionId]);

  const { noAuthGradeList, themeList, mediumList, unitList } = useSelector(
    state => state.masters
  );

  // Check if user is admin
  const isAdmin = authData?.roleType === ADMIN_ROLE_TYPE;

  // Filter grades for non-admin users (only grades 1-10); State content is grades 1-10 only
  const filteredGradeList = useMemo(() => {
    const restrictToPrimaryGrades = list =>
      (list || []).filter(
        gradeItem => gradeItem.gradeId >= 1 && gradeItem.gradeId <= 10
      );

    if (contentType === 'State') {
      return restrictToPrimaryGrades(noAuthGradeList);
    }
    if (isAdmin) {
      return noAuthGradeList;
    }
    return restrictToPrimaryGrades(noAuthGradeList);
  }, [noAuthGradeList, isAdmin, contentType]);

  const apiContentType = useMemo(
    () => (contentType ? mapContentTypeToApi(contentType) : ''),
    [contentType]
  );

  const fetchHomeContentRef = useRef(null);

  useEffect(() => {
    if (isUpdateLikeDislikeSuccess) {
      dispatch(getGamificationPoints(authData?.userId || 0));
      fetchHomeContentRef.current?.();
    }
  }, [
    isUpdateLikeDislikeLoading,
    isUpdateLikeDislikeSuccess,
    dispatch,
    authData?.userId
  ]);

  useEffect(() => {
    if (isGetContentTagsSuccess && contentTagList) {
      let result = contentTagList?.payload?.dataList || [];
      setContentTags(result);
    }
  }, [contentTagList, isGetContentTagsSuccess]);

  useEffect(() => {
    document.title = createTitle('Home');
    dispatch(getNoAuthGradeList());
    if (isAdmin) {
      dispatch(getThemeList());
    }
    dispatch(getMediumList());
    dispatch(getContentTags());
    dispatch(getSectionList());
    dispatch(revertResources());
    dispatch(
      getUserList({
        payload: { page: 0, size: 0, search: '', type: 'all' }
      })
    );
  }, [isAdmin]);

  const tagsFilter = useMemo(
    () => (Array.isArray(tags) ? tags.join(',') : ''),
    [tags]
  );

  const loadExtraFlashcardsRef = useRef(null);

  useEffect(() => {
    let isCancelled = false;

    const loadCategories = () => {
      if (isCancelled) {
        return;
      }
      const storedAuth = getAuthData();
      const resolvedContentType = apiContentType || '';
      dispatch(
        getContentByCategories({
          payload: {
            page: initialValues.page,
            size: initialValues.size,
            type: 'all',
            contentType: resolvedContentType
          },
          queryParam: {
            search: initialValues.searchFilter || '',
            grade: grade ?? '',
            userId: authData?.userId || storedAuth?.userId || '',
            tags: tagsFilter,
            themeId: theme ?? '',
            mediumId: medium ?? '',
            unitId: unit ?? '',
            contentType: resolvedContentType,
            loggedInUserName: authData?.userName || storedAuth?.userName || ''
          }
        })
      );
    };

    fetchHomeContentRef.current = () => {
      loadCategories();
      loadExtraFlashcardsRef.current?.();
    };

    loadCategories();

    return () => {
      isCancelled = true;
    };
  }, [
    dispatch,
    authData?.userId,
    authData?.userName,
    initialValues.page,
    initialValues.size,
    initialValues.searchFilter,
    grade,
    tagsFilter,
    theme,
    medium,
    unit,
    apiContentType
  ]);

  useEffect(() => {
    let isCancelled = false;

    const loadExtraFlashcards = () => {
      if (isCancelled) {
        return;
      }
      const storedAuth = getAuthData();
      const userId = authData?.userId || storedAuth?.userId;

      if (!userId || !flashcardsSectionId) {
        setExtraFlashcards([]);
        return;
      }

      dispatch(
        getAllContentBySection({
          payload: {
            page: 0,
            size: 50,
            type: 'all'
          },
          queryParam: {
            search: initialValues.searchFilter || '',
            grade: grade ?? '',
            sectionId: flashcardsSectionId,
            userId,
            encryptedContentId: '',
            tags: tagsFilter,
            themeId: theme ?? '',
            mediumId: medium ?? '',
            unitId: unit ?? '',
            contentType: apiContentType
          }
        })
      )
        .unwrap()
        .then(response => {
          if (isCancelled) {
            return;
          }
          const flashcardList = (response?.payload?.dataList || []).filter(
            item => {
              const type = (item?.upload_type || item?.uploadType || '')
                .replace(/\s+/g, '')
                .toLowerCase();
              return type === 'flashcard' || type === 'flashcards';
            }
          );
          setExtraFlashcards(flashcardList);
        })
        .catch(() => {
          if (!isCancelled) {
            setExtraFlashcards([]);
          }
        });
    };

    loadExtraFlashcardsRef.current = loadExtraFlashcards;
    loadExtraFlashcards();

    return () => {
      isCancelled = true;
    };
  }, [
    dispatch,
    authData?.userId,
    flashcardsSectionId,
    initialValues.searchFilter,
    grade,
    tagsFilter,
    theme,
    medium,
    unit,
    apiContentType
  ]);

  const handleTags = data => {
    setTags(data);
  };

  useEffect(() => {
    if (!isGamificationLoading && isGamificationSuccess) {
      dispatch(getGamificationPoints(authData?.userId || 0));
    }
    if (!isDeleteGamificationLoading && isDeleteGamificationSuccess) {
      dispatch(getGamificationPoints(authData?.userId || 0));
    }
  }, [
    isGamificationLoading,
    isGamificationSuccess,
    isDeleteGamificationLoading,
    isDeleteGamificationSuccess
  ]);

  const debouncedSearch = useCallback(
    _.debounce(term => {
      setInitalValues(prev => ({ ...prev, searchFilter: term, page: 0 }));
    }, 300),
    []
  );

  const handleSearch = e => {
    const term = e.target.value;
    // setSearch(term);
    if (term.length >= 3 || term.length === 0) {
      debouncedSearch(term);
    }
  };

  const gradeOptions = useMemo(
    () =>
      isArrayNotEmpty(filteredGradeList)
        ? filteredGradeList.map(c => ({ label: c.gradeName, id: c.gradeId }))
        : [],
    [filteredGradeList]
  );

  function getOptionLabel(option) {
    if (!option) {
      return '';
    }

    if (option.label !== null) {
      return option.label;
    }

    return '';
  }

  return (
    <>
      <Box>
        <TagsBar tags={contentTags} handleTags={handleTags} />

        <Box
          sx={{
            marginTop: '12px',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
          }}
        >
          <Search>
            <SearchIconWrapper>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 17.5L14.375 13.875M16.3333 9.16667C16.3333 12.8486 13.3486 15.8333 9.66667 15.8333C5.98477 15.8333 3 12.8486 3 9.16667C3 5.48477 5.98477 2.5 9.66667 2.5C13.3486 2.5 16.3333 5.48477 16.3333 9.16667Z"
                  stroke="#ABB4BD"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SearchIconWrapper>
            <StyledInputBase
              onChange={e => {
                searchValue = e.target.value;
                handleSearch(e);
              }}
              placeholder="Search here…"
            />
          </Search>
          <Select
            value={contentType || contentTypePlaceholder}
            onChange={event => {
              const selectedValue = event.target.value;
              if (selectedValue === contentTypePlaceholder) {
                return;
              }
              if (selectedValue === '') {
                setContentType('');
              } else {
                setContentType(selectedValue);
                if (selectedValue === 'State') {
                  setTheme('');
                  if (grade && grade > 10) {
                    setGrade('');
                  }
                }
                if (selectedValue === 'Core') {
                  setUnit('');
                }
                setContentTypePlaceholder('Select content type');
              }
            }}
            name="contentType"
            displayEmpty
            sx={{
              textAlign: 'left',
              width: '160px',
              height: '42px',
              marginLeft: '10px'
            }}
          >
            <MenuItem disabled value="Select content type">
              <em>Select content type</em>
            </MenuItem>
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {ALLOWED_CONTENT_TYPE_OPTIONS.map(option => (
              <MenuItem
                key={option.id}
                value={option.id}
                sx={{
                  ':hover': {
                    backgroundColor: colorSecondary
                  }
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {/* <Autocomplete
            size="small"
            value={grade}
            onChange={(event, newValue) => {
              setGrade(newValue);
            }}
            isOptionEqualToValue={(option, value) =>
              option.id === (value?.id ?? null)
            }
            getOptionLabel={getOptionLabel}
            // options={[]}
            options={gradeOptions}
            disableClearable
            renderInput={params => (
              <TextField
                name="grade"
                {...params}
                placeholder="Grade"
                sx={{ width: '140px' }}
              />
            )}
            ListboxProps={{
              sx: {
                '& .MuiAutocomplete-option:hover': {
                  backgroundColor: colorSecondary
                }
              }
            }}
          /> */}
          <Select
            className="step-grade"
            value={grade || placeholder}
            onChange={event => {
              const selectedValue = event.target.value;
              if (selectedValue === '') {
                setGrade('');
                setTheme('');
                setUnit('');
              } else {
                setGrade(selectedValue);
                // Fetch units for non-admin users
                if (!isAdmin) {
                  dispatch(getUnitsByGrade(selectedValue));
                  setUnit(''); // Reset unit when grade changes
                }
                // Clear theme if grade is SENIOR (11) or JUNIOR (12)
                if (selectedValue > 10) {
                  setTheme('');
                }
                setPlaceholder('Select grade');
              }
            }}
            name="grade"
            sx={{
              textAlign: 'left',
              width: '160px',
              height: '42px'
            }}
          >
            <MenuItem disabled value="Select grade">
              <em>Select grade</em>
            </MenuItem>
            {/* <MenuItem value="">
              <em>None</em>
            </MenuItem> */}
            {isArrayNotEmpty(filteredGradeList) &&
              filteredGradeList.map((row, key) => {
                return (
                  <MenuItem
                    key={key}
                    value={row?.gradeId}
                    sx={{
                      ':hover': {
                        backgroundColor: colorSecondary
                      }
                    }}
                  >
                    {row?.gradeName}
                  </MenuItem>
                );
              })}
          </Select>

          {/* Theme dropdown - Only show for admin users with grades 1-10 */}
          {isAdmin && grade && grade <= 10 && contentType !== 'State' && (
            <Select
              value={theme || themePlaceholder}
              onChange={event => {
                const selectedValue = event.target.value;
                if (selectedValue === '') {
                  setTheme('');
                } else {
                  setTheme(selectedValue);
                  setThemePlaceholder('Select theme');
                }
              }}
              name="theme"
              sx={{
                textAlign: 'left',
                width: '160px',
                height: '42px',
                marginLeft: '10px'
              }}
            >
              <MenuItem disabled value="Select theme">
                <em>Select theme</em>
              </MenuItem>
              {isArrayNotEmpty(themeList) &&
                themeList.map((row, key) => {
                  return (
                    <MenuItem
                      key={key}
                      value={row?.themeId}
                      sx={{
                        ':hover': {
                          backgroundColor: colorSecondary
                        }
                      }}
                    >
                      {row?.themeName}
                    </MenuItem>
                  );
                })}
            </Select>
          )}

          {/* Medium dropdown - show for all users */}
          <Select
            value={medium || mediumPlaceholder}
            onChange={event => {
              const selectedValue = event.target.value;
              if (selectedValue === '') {
                setMedium('');
              } else {
                setMedium(selectedValue);
                setMediumPlaceholder('Select medium');
              }
            }}
            name="medium"
            sx={{
              textAlign: 'left',
              width: '160px',
              height: '42px',
              marginLeft: '10px'
            }}
          >
            <MenuItem disabled value="Select medium">
              <em>Select medium</em>
            </MenuItem>
            {isArrayNotEmpty(mediumList) &&
              mediumList.map((row, key) => {
                return (
                  <MenuItem
                    key={key}
                    value={row?.mediumId}
                    sx={{
                      ':hover': {
                        backgroundColor: colorSecondary
                      }
                    }}
                  >
                    {row?.mediumName}
                  </MenuItem>
                );
              })}
          </Select>

          {/* Unit dropdown - Only for non-admin users and when grade is selected */}
          {!isAdmin && grade && contentType !== 'Core' && (
            <Select
              value={unit || unitPlaceholder}
              onChange={event => {
                const selectedValue = event.target.value;
                if (selectedValue === '') {
                  setUnit('');
                } else {
                  setUnit(selectedValue);
                  setUnitPlaceholder('Select unit');
                }
              }}
              name="unit"
              sx={{
                textAlign: 'left',
                width: '160px',
                height: '42px',
                marginLeft: '10px'
              }}
            >
              <MenuItem disabled value="Select unit">
                <em>Select unit</em>
              </MenuItem>
              {isArrayNotEmpty(unitList) &&
                unitList.map((row, key) => {
                  return (
                    <MenuItem
                      key={key}
                      value={row?.unitId}
                      sx={{
                        ':hover': {
                          backgroundColor: colorSecondary
                        }
                      }}
                    >
                      {row?.unitName}
                    </MenuItem>
                  );
                })}
            </Select>
          )}
        </Box>
        {isGetContentLoading ? (
          <div
            style={{
              marginTop: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '70vh'
            }}
          >
            <CircularProgress size={50} />
          </div>
        ) : (
          <div style={{ marginTop: '1rem' }}>
            {!isGetContentLoading && homeSections.length > 0 ? (
              homeSections.map((section, index) => (
                <ContentSection
                  key={section?.sectionId ?? index}
                  title={section?.sectionName}
                  videoCount={section?.videoCount || 0}
                  documentCount={section?.documentCount || 0}
                  audioCount={section?.audioCount || 0}
                  flashCardsCount={section?.flashcardCount || 0}
                  videos={section?.contents || []}
                  sectionId={section?.sectionId}
                  tags={tags}
                  grade={grade ?? ''}
                  contentType={contentType ?? ''}
                />
              ))
            ) : !isGetContentLoading ? (
              <Box
                sx={{
                  marginBottom: 4,
                  backgroundColor: '#FFFFFF',
                  padding: '16px',
                  borderRadius: '8px',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '14px',
                    fontWeight: 700,
                    color: colorTextGrey
                  }}
                >
                  {' '}
                  No content available
                </Typography>
              </Box>
            ) : null}
          </div>
        )}
      </Box>

      {!isShareDetailsLoading &&
        isShareDetailsSuccess &&
        shareDetailsResponse && (
          <SnackBarBox
            type="success"
            message={handleError(shareDetailsResponse?.payload?.message)}
          />
        )}

      {!isShareDetailsLoading &&
        shareDetailsErrorContainer &&
        isShareDetailsFailed && (
          <SnackBarBox
            type="error"
            message={handleError(shareDetailsErrorContainer?.errorMessage)}
          />
        )}
    </>
  );
}

export const TagsBar = ({ tags, handleTags }) => {
  const [showArrows, setShowArrows] = useState(false);
  const [selectedTagList, setSelectedTagList] = useState([]);
  const containerRef = useRef(null);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  useLayoutEffect(() => {
    if (containerRef.current) {
      setShowArrows(
        containerRef.current.scrollWidth > containerRef.current.clientWidth
      );
    }
  }, [tags]);

  const handleOnClickTag = tagId => {
    let tempTagList = [...selectedTagList];

    if (tempTagList.includes(tagId)) {
      tempTagList = tempTagList.filter(id => id !== tagId);
    } else {
      tempTagList.push(tagId);
    }
    setSelectedTagList(tempTagList);
    handleTags(tempTagList);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {showArrows && (
        <IconButton onClick={scrollLeft}>
          <ArrowBackIos />
        </IconButton>
      )}

      <Box
        ref={containerRef}
        sx={{
          display: 'flex',
          overflowX: 'hidden',
          // border: '1px solid red',
          padding: 0.3,
          flexGrow: 1,
          '&::-webkit-scrollbar': { display: 'none' }
        }}
      >
        {tags.map((tag, index) => (
          <Chip
            label={tag?.tagName}
            key={index}
            sx={{
              marginRight: 1,
              border: selectedTagList.includes(tag?.contentTagId)
                ? '2px solid #F4C24A'
                : '1px solid #F7D178',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 600,
              fontFamily: 'Lato',
              backgroundColor: selectedTagList.includes(tag?.contentTagId)
                ? '#FCEBC5'
                : '#FEF8EC',
              '&:hover': {
                backgroundColor: '#FCEBC5',
                borderColor: '#F4C24A'
              }
            }}
            onClick={() => handleOnClickTag(tag?.contentTagId)}
            color="secondary"
          />
        ))}
      </Box>

      {/* <UserRatingsModal isOpen={true} /> */}

      {showArrows && (
        <IconButton onClick={scrollRight}>
          <ArrowForwardIos />
        </IconButton>
      )}
    </Box>
  );
};
